module.exports = __webpack_public_path__ + "assets/img/body_bg2.b50af07d.jpg";